// PC-STUDIO-SYNC-RESPONSIVE-FIX-1 · PC Studio 적용 상태 표시 (영상 위 그래픽 대신 관리 영역에 상태 문구).
import React, { useEffect, useState } from 'react';
import { timerViewOf } from '@/lib/timerLocal';
import { noticeType } from '@/lib/testLiveShare';

const TIMER_TXT = { running: '진행 중', paused: '일시정지', finished: '종료' };

const Item = ({ label, on, value, testid }) => (
  <span className={`inline-flex items-center gap-1 min-w-0 px-2 py-1 rounded-full border text-[11px] ${on ? 'border-[#FF3B30]/40 bg-[#FF3B30]/5' : 'border-[#E5E7EB] dark:border-white/10 text-gray-400'}`}
        data-testid={testid} data-on={on ? '1' : '0'}>
    <b className="shrink-0">{label}</b>
    <span className="truncate max-w-[14rem]">{value}</span>
  </span>
);

export const PcStatusStrip = ({ test, product, qr, notice, timer, ext }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (timer?.status !== 'running') return undefined;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [timer?.status]);
  const tv = timerViewOf(timer, now);
  return (
    <div className="flex items-center gap-1.5 flex-wrap px-5 py-2 border-b border-[#E5E7EB] dark:border-white/10" data-testid="pc-status-strip">
      <span className={`shrink-0 px-2 py-0.5 rounded text-[10px] font-black ${test ? 'bg-amber-500/15 text-amber-700' : 'bg-[#FF3B30] text-white'}`}
            data-testid="pc-status-scope">{test ? 'TEST 상태' : '실제 송출 상태'}</span>
      <Item label="상품" on={!!product} value={product ? `소개 중 · ${product}` : '소개 상품 없음'} testid="pc-status-product" />
      <Item label="QR" on={qr} value={qr ? '노출 중' : '꺼짐'} testid="pc-status-qr" />
      <Item label="공지" on={!!notice} value={notice ? `표시 중 · ${notice}` : '없음'} testid="pc-status-notice" />
      <Item label="타이머" on={!!tv} value={tv ? `${TIMER_TXT[tv.status] || ''} · ${tv.label} ${tv.display}` : '대기'} testid="pc-status-timer" />
      <Item label="외부공지" on={!!ext} value={ext ? `선택됨 · ${noticeType(ext) === 'image' ? '이미지' : ext.text}` : '없음'} testid="pc-status-ext" />
    </div>
  );
};

export default PcStatusStrip;
